import React from 'react'
import CountUp from 'react-countup';

export default function Satisfy() {
  return (
    <div className="bg-dark text-light py-3 mt-1 ">
      <div className="container text-center">
        <div className="row">
          <div className="col-sm">
            <p><h2><b><CountUp start={0} end={35} duration={5} />k+</b></h2>
              Happy Customer
            </p>
          </div>
          <div className="col-sm">

            <p><h2><b><CountUp start={0} end={35} duration={5} />k+</b></h2>
              Success Projects
            </p>
          </div>
          <div className="col-sm">
            <p><h2><b><CountUp start={0} end={200} duration={5} />%</b></h2>
              Conversion Rate Increased
            </p>
          </div>
          <div className="col-sm">
            <p><h2><b><CountUp start={0} end={120} duration={5} />+</b></h2>
              Award Winning
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
